import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SelectedInsuranceFragment } from '@websky/graphql';
import { useTheme } from '../../../../theme';
import { Download } from '../../../../Icons';
import { default as BaseButton } from '../../../../BaseComponents/Button';

interface Props {
	selectedInsurances: SelectedInsuranceFragment[];
}

const DownloadInsurances: React.FC<Props> = ({ selectedInsurances }) => {
	const theme = useTheme('AdditionalServices').DownloadInsurances;
	const { t } = useTranslation('Checkout');

	const confirmedInsurances = selectedInsurances.filter(insurance => !!insurance.policyUrl);

	return (
		<div className={theme.wrapper}>
			{confirmedInsurances.map((insurance, index) => (
				<div key={index} className={theme.item}>
					<span className={theme.name}>{insurance.passengerName.toLowerCase()}</span>

					<a href={insurance.policyUrl} target="_blank">
						<BaseButton className={theme.button} variant="optionAction">
							{t('Download')}
							{Download}
						</BaseButton>
					</a>
				</div>
			))}
		</div>
	);
};

export default DownloadInsurances;
